export default "__VITE_ASSET__DypLw8Z___"